export default __webpack_public_path__ + "static/media/decada-2000-0003-min.33d6a4a4.jpg";